import { ReactNode } from "react";

import AccessGate from "~/components/AccessGate";
import { userStore } from "~/stores/user";

export interface ILoggedContent{
	children: ReactNode;
	unauthorized?: boolean;
}

export default function LoggedContent({
	children = null,
	unauthorized = false,
} : ILoggedContent) {
	const userData = userStore(userState => userState.user);

	return <div className="loggedCont">
		{ userData.email && children }
		{ unauthorized && !userData.email && <AccessGate reason="login" /> }
	</div>;
}
